import { createAsyncThunk } from "@reduxjs/toolkit";

import apiRequest from "../../../services/api";

// Fetch target dashboard data
export const fetchDashboardData = createAsyncThunk(
  "psc/dashboard",
  async (body, { rejectWithValue }) => {
    try {
      let query = `period=${body.period ? body.period : "current_month"}`;
      const dashboardApi = await apiRequest.get(
        `v1/provider_scorecard/dashboard/?${query}`,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return dashboardApi.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Fetch target clinical dashboard data
export const fetchClinicalDashboardData = createAsyncThunk(
  "psc/dashboard/clinical",
  async (body, { rejectWithValue }) => {
    try {
      let query = `period=${body.period ? body.period : "current_month"}`;
      if (body.version) {
        query = query + `&version=${body.version}`;
      }
      const dashboardApi = await apiRequest.get(
        `v1/provider_scorecard/dashboard/clinical?${query}`,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return dashboardApi.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Dashboard data export
export const pscDashboardDataExport = createAsyncThunk(
  "psc/dashboard/export",
  async (body, thunkAPI) => {
    let query = `period=${body.period}`;
    if (body.type) {
      query = query + `&type=${body.type}`;
    }
    const pscApi = await apiRequest
      .get(`v1/provider_scorecard/dashboard/?${query}`, {
        headers: { organization: body.userOrganization.org_id },
      })
      .catch((e) => {
        throw thunkAPI.rejectWithValue(e.response.data);
      });
    return pscApi.data;
  }
);

// fetch configurations list
export const fetchConfigurationList = createAsyncThunk(
  "psc/configurations/list",
  async (body, { rejectWithValue }) => {
    let query = `page=${body.page ? body.page : 1}`;
    if (body.page_size) {
      query = query + `&page_size=${body.page_size}`;
    }
    if (body.ordering) {
      query = query + `&ordering=${body.ordering}`;
    }
    try {
      const pscApi = await apiRequest.get(
        `v1/provider_scorecard/configurations/?${query}`,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return pscApi.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Create configuration
export const createConfiguration = createAsyncThunk(
  "psc/configurations/create",
  async (body, { rejectWithValue }) => {
    try {
      const pscApi = await apiRequest.post(
        `v1/provider_scorecard/configurations/`,
        body.newConfigData,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return pscApi;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Update configuration
export const updateConfiguration = createAsyncThunk(
  "psc/configurations/update",
  async (body, { rejectWithValue }) => {
    try {
      const pscApi = await apiRequest.put(
        `v1/provider_scorecard/configurations/${body.configurationId}/`,
        body.updatedConfigData,
        {
          headers: {
            organization: body.userOrganization.org_id,
          },
        }
      );
      return pscApi.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Delete feed editorial
export const deleteConfiguration = createAsyncThunk(
  "psc/configurations/update",
  async (body, { rejectWithValue }) => {
    try {
      const pscApi = await apiRequest.delete(
        `v1/provider_scorecard/configurations/${body.configurationId}/`,
        {
          headers: { organization: body.userOrganization.org_id },
        }
      );
      return pscApi.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

// Fetch configuration detail
export const fetchConfigurationDetail = createAsyncThunk(
  "psc/configurations/details",
  async (body) => {
    const pscApi = await apiRequest.get(
      `v1/provider_scorecard/configurations/${body.configurationId}/`,
      {
        headers: { organization: body.userOrganization.org_id },
      }
    );
    return pscApi.data;
  }
);
